const config = {
    X_SERVICE_PROVIDER: "sbremit-web-prod",
    API_HOST: 'https://sbremit.com:9090',
    APP_HOST: 'https://sbremit.com'
}

export default config;